import chevronDown from '@iconify/icons-carbon/chevron-down';
import chevronRight from '@iconify/icons-carbon/chevron-right';
import { Box, Collapse, Link, ListItemText, Typography } from '@mui/material';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { type ComponentType, type FC, useState } from 'react';

import { NavList, Iconify } from '@larvitu/shared/mui/ui-components';

import { StyledListItemButton } from './StyledListItemButton';

interface NavItemProps {
  title: string;
  path: string;
  icon?: JSX.Element;
  info?: JSX.Element;
  children?: Array<{
    title: string;
    path: string;
  }>;
}

interface NavItemMobileProps {
  item: Record<string, unknown> & {
    title: string; path: string, children?:
      Array<{
        subheader: string;
        isActiveSub: boolean;
        items: NavItemProps[];
      } & NavItemProps>
  };
  activeItem: ComponentType;
}

// eslint-disable-next-line max-statements
export const NavMobileItem: FC<NavItemMobileProps> = ({
                                                        item,
                                                        activeItem: ActiveItem = () => null,
                                                      }) => {
  const {pathname} = useRouter();
  const {t} = useTranslation('common');

  const {title, path, children} = item;
  const [, rootPath] = pathname.split('/');
  const isActiveRoot = pathname === path;

  const isActiveRootWithChild = pathname.includes(`/${rootPath}/`);

  const [open, setOpen] = useState(isActiveRootWithChild);

  const handleOpen = (): void => setOpen(!open);

  if (children) {
    return (
      <Box display="flex" flexDirection="column" width="100%">
        <StyledListItemButton active={isActiveRootWithChild || isActiveRoot}>
          <NextLink key={title} href={path}>
            <ListItemText
              disableTypography
              primary={
                <Typography>
                  {t(title, {ns: 'common', defaultValue: ''})}
                </Typography>
              }
            />
          </NextLink>
          <ActiveItem/>
          <Iconify
            onClick={handleOpen}
            icon={open ? chevronDown : chevronRight}
            sx={{
              // mr: 0,
              // ml: 'auto',
              width: 16,
              height: 16,
              ml: 1,
            }}
          />
        </StyledListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse',
              width: 'max-content',
              mx: 'auto',
            }}
          >
            <NavList subNavConfig={children}/>
          </Box>
        </Collapse>
      </Box>
    );
  }

  return (
    <NextLink key={title} href={path}>
      <StyledListItemButton active={isActiveRoot}>
        <ListItemText
          disableTypography
          primary={
            <Typography>
              {t(title, {ns: 'common', defaultValue: ''})}
            </Typography>
          }
        />
        <ActiveItem/>
      </StyledListItemButton>
    </NextLink>
  );
};

export default NavMobileItem;
